/**
 * Affiliate (influencer) endpoints.
 *
 * Kept out of `API_ENDPOINTS` because only the control panel and the affiliate
 * portal touch these routes; a member bundle that never imports this module
 * never carries these paths.
 *
 * `LIST`, `ADMIN_REVIEW`, `SEND_PAYOUT`, `OVERRIDE_REFERRAL_ELIGIBILITY` and the
 * qualification-rule pair are operator-only and run on the member (admin)
 * bearer. Everything else is also reachable from the affiliate portal, which
 * signs in with `VALIDATE_LOGIN` and carries its own bearer.
 *
 * `REFERRALS` is shared but not symmetric: an operator reads any affiliate's
 * referrals in full, while the API pins the request to the caller and masks the
 * referred user's identity for an affiliate — so the same route answers two
 * different shapes depending on which bearer it was called with.
 *
 * `DELETE` is the exception to that split: the API lets an operator delete any
 * affiliate and an affiliate delete only their own, but only the control panel
 * calls it today, so it is wired on the member bearer alone.
 *
 * The password-reset trio is anonymous by nature — a locked-out affiliate has
 * no bearer — and is separate from the member `Auth` routes: an affiliate is
 * not a member, so the member reset endpoints do not know the account.
 */
const AFFILIATE_ENDPOINTS = {
  LIST: '/api/v1/Affiliate/GetAllAffiliate',
  BY_ID: '/api/v1/Affiliate/GetAffiliateById',
  ADMIN_REVIEW: '/api/v1/Affiliate/AdminReviewAffiliate',
  DELETE: '/api/v1/Affiliate/DeleteAffiliate',
  VALIDATE_LOGIN: '/api/v1/Affiliate/AffiliateValidateLogin',
  REGISTER: '/api/v1/Affiliate/AffiliateRegister',
  FORGOT_PASSWORD: '/api/v1/Affiliate/ForgotPassword',
  VERIFY_PASSWORD_RESET_OTP: '/api/v1/Affiliate/VerifyPasswordResetOtp',
  RESET_PASSWORD: '/api/v1/Affiliate/ResetPassword',
  UPDATE_PROFILE: '/api/v1/Affiliate/UpdateAffiliateProfile',
  REFERRAL_CODES: '/api/v1/Affiliate/GetAffiliateReferralCodes',
  CREATE_REFERRAL_CODE: '/api/v1/Affiliate/CreateAffiliateReferralCode',
  UPDATE_REFERRAL_CODE: '/api/v1/Affiliate/UpdateAffiliateReferralCode',
  DELETE_REFERRAL_CODE: '/api/v1/Affiliate/DeleteAffiliateReferralCode',
  REFERRALS: '/api/v1/Affiliate/GetAffiliateReferrals',
  OVERRIDE_REFERRAL_ELIGIBILITY:
    '/api/v1/Affiliate/AdminOverrideReferralEligibility',
  QUALIFICATION_RULE: '/api/v1/Affiliate/GetAffiliateQualificationRule',
  UPDATE_QUALIFICATION_RULE: '/api/v1/Affiliate/UpdateAffiliateQualificationRule',
  SEND_PAYOUT: '/api/v1/Affiliate/Paypal/SendInfluencerPayout',
} as const;

export default AFFILIATE_ENDPOINTS;
